<template>
  <div class="root">
    <div class="top">实名认证</div>
    <template v-if="step == 1">
    <div class="panel">
      <div class="title-1">1、请上传二代身份证</div>
      <div class="title-2">请确保上传本人清晰、完整、有效的身份证</div>
      <div class="upload-box">
        <div class="box-item">
          <van-uploader :after-read="afterReadFront" class="img">
            <img :src="fileForm.front.content" v-if="fileForm.front" class="idcard"/>
            <img src="../assets/newimg/guohui.png" v-else class="idcard"/>
            <img src="../assets/newimg/shangchuan.png" class="icon"/>
          </van-uploader>
          <div class="text">上传人像面</div>
        </div>
        <div class="box-item">
          <van-uploader :after-read="afterReadBack" class="img">
            <img :src="fileForm.back.content" v-if="fileForm.back" class="idcard"/>
            <img src="../assets/newimg/guohui.png" v-else class="idcard"/>
            <img src="../assets/newimg/shangchuan.png" class="icon"/>
          </van-uploader>
          <div class="text">上传国徽面</div>
        </div>
      </div>
      <div class="tips">
        <div class="tips-item">
          <img src="../assets/newimg/cuowu.png"/>
          <span>边框缺失</span>
        </div>
        <div class="tips-item">
          <img src="../assets/newimg/cuowu.png"/>
          <span>照片模糊</span>
        </div>
        <div class="tips-item">
          <img src="../assets/newimg/cuowu.png"/>
          <span>反光强烈</span>
        </div>
      </div>
      <div class="step" @click="netStep">下一步</div>
    </div>
    </template>
    <template v-else>
      <div class="panel">
        <div class="title-1">2、请完成手机验证</div>
        <div class="phone-form">
          <div class="input-control">
            <div class="label">手机号</div>
            <input v-model="ruleForm.mobile" placeholder="请输入您的11位手机号码" />
          </div>
          <div class="input-control">
            <div class="label">验证码</div>
            <input v-model="ruleForm.code" />
            <span class="addon" @click="handleSms">{{ smsBtnTxt }}</span>
          </div>
        </div>
        <div class="btn-group">
          <div class="return-btn" @click="step=1">上一步</div>
          <div class="submit" @click="submit">提交</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "authpage",
  data() {
    return {
      step: 1,
      ruleForm:{

      },
      fileForm:{
        front:'',
        back:'',
      },
      sms:false,
      smsBtnTxt:'发送验证码',
    }
  },
  methods:{
    async submit(){
      if(!this.fileForm.front){
        this.step = 1;
        return this.$toast('请上传人像面')
      }
      if(!this.fileForm.back){
        this.step = 1;
        return this.$toast('请上传国徽面')
      }
      if(!this.ruleForm.mobile || !this.ruleForm.code){
        return this.$toast('请输入手机号和验证码')
      }
      this.$toast.loading({duration:0,forbidClick:true,message:'认证中'})
      let uploadres
      if(!this.ruleForm.front) {
        uploadres = await this.uploadsync('/base/upload', this.fileForm.front.file)
        if (!uploadres.code) {
          return this.$toast(uploadres.msg)
        }
        this.ruleForm.front = uploadres.data
      }
      if(!this.ruleForm.back) {
        uploadres = await this.uploadsync('/base/upload', this.fileForm.back.file)
        if (!uploadres.code) {
          return this.$toast(uploadres.msg)
        }
        this.ruleForm.back = uploadres.data
      }
      this.post("/card/localtuth",this.ruleForm).then(res=>{
        this.$toast.loading().clear();
        this.$toast(res.msg)
        if(res.code){
          this.$router.back()
        }
      }).catch(err=>{})
    },
    netStep(){
      if(!this.fileForm.front){
        return this.$toast('请上传人像面')
      }
      if(!this.fileForm.back){
        return this.$toast('请上传国徽面')
      }
      this.step = 2
    },
    afterReadFront(file){
      if(file.size > 2*1024*1024){
        return this.$toast("请上传小于2M的图片")
      }
      this.fileForm.front = file
    },
    afterReadBack(file){
      if(file.size > 2*1024*1024){
        return this.$toast("请上传小于2M的图片")
      }
      this.fileForm.back = file
    },
    handleSms(){
      if(!/^1[\d]{10}/.test(this.ruleForm.mobile)){
        return this.$toast("请输入正确的手机号码")
      }
      if(this.sms == false) {
        this.sms = true
        this.$toast.loading({duration:0,forbidClick:true})
        this.fetchData('/sms/send', {mobile: this.ruleForm.mobile}, (res) => {
          this.$toast.clear();
          if (res.code) {
            this.$toast('发送成功')
            let s = 60;
            let intval = setInterval(()=>{
              this.smsBtnTxt = s+'秒重发'
              if(s <= 0){
                this.smsBtnTxt = '发送验证码';
                this.sms = false;
                clearInterval(intval);
              }
              s--;
            },1000)

          } else {
            this.sms = false;
            this.$toast('发送失败')
          }
        })
      }
    },
  },
  created() {
    this.ruleForm.iccid = this.$route.query.iccid
  }
}
</script>
<style scoped>
.root {
  min-height: 100vh;
  padding-bottom: .3rem;
  background: #eef4ff;
  overflow-y: auto;
}

.top {
  font-size: .2rem;
  text-align: center;
  font-weight: 600;
  color: #fff;
  padding: .16rem 0;
  background: linear-gradient(135deg, #3f72ff, #3a9bff);
}

.panel {
  width: calc(100% - .24rem);
  margin: .12rem auto 0;
  padding: .14rem .12rem;
  border-radius: .12rem;
  background: #fff;
  box-shadow: 0 .04rem .14rem rgba(47, 102, 255, .08);
}

.title-1 {
  text-align: center;
  font-size: .16rem;
  font-weight: 600;
  color: #1f2a44;
}

.title-2 {
  margin-top: .06rem;
  font-size: .12rem;
  text-align: center;
  color: #7d879b;
}

.upload-box {
  margin-top: .12rem;
}

.box-item + .box-item {
  margin-top: .12rem;
}

.text {
  text-align: center;
  font-size: .12rem;
  color: #4a556b;
  margin-top: .06rem;
}

.img {
  width: 100%;
  height: 1.52rem;
  position: relative;
  border-radius: .1rem;
  border: 1px dashed #a9bee9;
  background: #f4f8ff;
  text-align: center;
  display: block;
}

.idcard {
  width: 2.5rem;
  height: 1.44rem;
  margin: .04rem auto;
  display: inline-block;
  object-fit: contain;
}

.icon {
  position: absolute;
  width: .34rem;
  height: .34rem;
  left: 50%;
  top: 50%;
  margin-left: -.17rem;
  margin-top: -.17rem;
}

.tips {
  margin-top: .12rem;
  display: flex;
  justify-content: space-between;
}

.tips-item {
  display: inline-flex;
  align-items: center;
  gap: .04rem;
}

.tips-item img {
  width: .12rem;
  height: .12rem;
  display: inline-block;
}

.tips-item span {
  font-size: .11rem;
  color: #ff5f5f;
}

.step,
.btn-group div {
  color: #fff;
  min-width: 1.06rem;
  height: .36rem;
  border-radius: .08rem;
  line-height: .36rem;
  text-align: center;
  font-size: .14rem;
}

.step {
  margin: .14rem auto 0;
  background: linear-gradient(135deg, #3f72ff, #3a9bff);
}

.phone-form {
  margin-top: .12rem;
}

.input-control {
  position: relative;
}

.input-control + .input-control {
  margin-top: .1rem;
}

.label {
  line-height: .24rem;
  font-size: .13rem;
  color: #42506b;
}

.input-control input {
  width: 100%;
  border: 1px solid #d7e2fb;
  background: #f6f9ff;
  border-radius: .08rem;
  height: .38rem;
  line-height: .38rem;
  text-indent: .1rem;
  padding: 0;
  font-size: .13rem;
  box-sizing: border-box;
}

.addon {
  position: absolute;
  line-height: .38rem;
  bottom: 0;
  right: .1rem;
  color: #2f7df6;
  font-size: .12rem;
}

.btn-group {
  display: flex;
  justify-content: center;
  gap: .12rem;
  margin-top: .16rem;
}

.return-btn {
  background: #9aa7bf;
}

.submit {
  background: linear-gradient(135deg, #3f72ff, #3a9bff);
}
</style>



// WEBPACK FOOTER //
// src/pages/authpage.vue